export default __webpack_public_path__ + "static/media/AmazonLogo.1d446971.png";